import { useState } from 'react';
import api from '../lib/api';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { KeyRound } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from './ui/dialog';

export function ResetPasswordDialog({ email, name, testId }) {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    setSaving(true);
    try {
      await api.post('/auth/reset-password', { email, new_password: pw });
      toast.success(`Password reset for ${email}`);
      setOpen(false); setPw('');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setPw(''); }}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-amber-600 hover:text-amber-700 hover:bg-amber-50" title="Reset password" data-testid={testId}>
          <KeyRound size={14} />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid={`${testId}-dialog`}>
        <DialogHeader><DialogTitle className="font-heading">Reset Password</DialogTitle><DialogDescription>Set a new login password for this user.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <p className="text-sm text-slate-500">Set a new password for <span className="font-medium text-slate-800">{name || email}</span>.</p>
          <div className="form-field">
            <Label>New Password *</Label>
            <Input type="text" value={pw} onChange={(e) => setPw(e.target.value)} className="bg-slate-50 font-mono" placeholder="Min 6 characters" data-testid={`${testId}-input`} />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button type="submit" disabled={saving} className="bg-slate-900 hover:bg-slate-800" data-testid={`${testId}-submit`}>{saving ? 'Saving...' : 'Reset Password'}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
